import React from 'react';
import { QrisAccountStatus, QrisAccountType } from '../types';

export const QRIS_STATUS_STYLE: Record<QrisAccountStatus, { label: string; className: string }> = {
  awaiting_payment: { label: 'Menunggu Bayar', className: 'bg-gray-100 text-gray-600' },
  draft: { label: 'Mengisi Formulir', className: 'bg-gray-100 text-gray-600' },
  submitted: { label: 'Perlu Diekspor', className: 'bg-blue-100 text-blue-700' },
  uploaded: { label: 'Menunggu Paydia', className: 'bg-yellow-100 text-yellow-800' },
  active: { label: 'Aktif', className: 'bg-green-100 text-green-700' },
  rejected: { label: 'Ditolak', className: 'bg-red-100 text-red-700' },
  refund_pending: { label: 'Perlu Refund', className: 'bg-orange-100 text-orange-800' },
  refunded: { label: 'Direfund', className: 'bg-gray-100 text-gray-600' },
};

export const qrisStatusBadge = (status: QrisAccountStatus) => (
  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${QRIS_STATUS_STYLE[status]?.className ?? 'bg-gray-100 text-gray-600'}`}>
    {QRIS_STATUS_STYLE[status]?.label ?? status}
  </span>
);

export const QRIS_TYPE_LABEL: Record<QrisAccountType, string> = {
  individual: 'Perorangan',
  business: 'Badan Usaha',
};

/** Pesan error dari respons JSON biasa (422 errors / message). */
export const qrisErrorMessage = (err: any, fallback: string): string => {
  const errors = err?.response?.data?.errors;
  if (errors) {
    const first = Object.values(errors)[0];
    if (Array.isArray(first) && first.length) return String(first[0]);
  }
  return err?.response?.data?.message || fallback;
};

/** Unduhan blob: error 4xx datang sebagai Blob, jadi isinya perlu dibaca dulu. */
export const qrisBlobErrorMessage = async (err: any, fallback: string): Promise<string> => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      if (parsed?.message) return String(parsed.message);
    } catch {
      /* bukan JSON */
    }
    return fallback;
  }
  return qrisErrorMessage(err, fallback);
};

export const saveBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const todayStamp = () => {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export interface PaydiaActivation {
  mid: string;
  merchantPan: string;
  clientId: string;
  clientSecret: string;
}

/**
 * Isi form Aktifkan dari respons Import Merchant Paydia:
 * { data: { merchant_mid, merchant_pan, secret_id, secret_key } }. Null bila bukan JSON itu.
 */
export const parsePaydiaImportResponse = (text: string): PaydiaActivation | null => {
  let parsed: any;
  try {
    parsed = JSON.parse(text);
  } catch {
    return null;
  }
  const d = parsed?.data ?? parsed;
  if (!d || typeof d !== 'object' || !d.merchant_mid || !d.secret_id || !d.secret_key) return null;
  return {
    mid: String(d.merchant_mid),
    merchantPan: d.merchant_pan ? String(d.merchant_pan) : '',
    clientId: String(d.secret_id),
    clientSecret: String(d.secret_key),
  };
};
